export const formatNumber = (number: number | undefined) =>
  number === undefined ? 0 : new Intl.NumberFormat().format(number);
